export const BASIC_TOPIC_DETAILS_SECTION_I18N_PREFIX = "features.topics.components.edit_topic.basic_topic_details_section";

export const BASIC_TOPIC_DETAILS_SECTION_I18N_KEYS = {
  topic_name:          "topic_name",
  description:         "description",
  no_description_text: "no_description_text",
  categories:          "categories",
  email_when_ready:    "email_when_ready",
  yes:                 "yes",
  no:                  "no"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/edit-topic/constants/i18n/BasicTopicDetailsSectioni18nConstants.js